import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import useRedirect from 'src/hooks/useRedirect';
import GridCellBase from './GridCellBase';

const GoToHistoryCell = (props: GridCellProps) => {
  const { getUrl, redirect } = useRedirect();
  let { poId = '' } = props.dataItem;

  const url = useMemo(
    () =>
      props.dataItem.invoiceId
        ? getUrl('invoiceDetails')(props.dataItem.invoiceId, poId)
        : props.dataItem.receiptId
        ? getUrl('receiptDetails')(props.dataItem.receiptId, poId)
        : props.dataItem.varianceId
        ? getUrl('varianceDetails')(poId, props.dataItem.varianceId)
        : getUrl('poDetails')(poId),
    [getUrl, poId, props.dataItem.invoiceId, props.dataItem.receiptId, props.dataItem.varianceId]
  );

  const handleClick = useCallback(() => {
    redirect(url, url.includes('http'));
  }, [url, redirect]);

  return (
    <GridCellBase {...props} title={props.dataItem.document}>
      <button onClick={handleClick} className="text-link cursor-pointer text-underline">
        {props.dataItem.document.split(':')[0]}
      </button>
    </GridCellBase>
  );
};

export default GoToHistoryCell;
